import { useState, useEffect } from 'react';
import { BsArrowRightShort } from "react-icons/bs";
import { IoArrowForwardCircle } from "react-icons/io5";
import { RxDashboard } from "react-icons/rx";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import { BASE_URL } from "../../insightConfig/insightConfig";
import "../ReusableComponent/CIVIL/CivilrightSection/CivilrightSection.css";
import SocialComponent from '../SocialComponent/SocialComponent';
import ImageComponent1 from '../ImageComponent/ImageComponent1';
import Loader from '../Loader/Loader';


function CurrentAffair({ componentName, onDateSelect }) {
    const [selectedDate, setSelectedDate] = useState('');
    const [allArticles, setAllArticles] = useState([]);
    const [articleTypes, setArticleTypes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedArticle, setSelectedArticle] = useState(null);

    useEffect(() => {
        if (componentName === "Cuet" || componentName === "neet" || componentName === "ugc_net") {
            setLoading(true);
            const apiPrefix = componentName === "Cuet" ? "cuet" : componentName === "neet" ? "neet" : "ugc";
            // Fetch both articles and their types in parallel
            Promise.all([
                axios.get(`${BASE_URL}/${apiPrefix}/articles`),
                axios.get(`${BASE_URL}/getArticleTypes`)
            ])
            .then(([articlesRes, typesRes]) => {
                setAllArticles(articlesRes.data.data || []);
                const types = typesRes.data.data || [];
                // Only show active types
                setArticleTypes(types.filter(t => t.Status === 1));
            })
            .catch(err => console.error("Error fetching data:", err))
            .finally(() => setLoading(false));
        }
    }, [componentName]);

    const handleDateChange = (event) => {
        const date1 = event.target.value;
        const date2 = event.target.value;
        setSelectedDate(date1);

        onDateSelect(date1, date2); // Pass selected date to parent component
        handleScrollToTop()

    };

    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            {componentName === "Blog" ? (
                <div className="card">
                    <div className="card-header list-background Affair-background py-2 fs-5 text-white">
                        <input type="date" value={selectedDate} onChange={handleDateChange} style={{ cursor: "pointer!important", background: "none", width: "30px", color: "white", border: "none", borderColor: "white" }} className='me-2 mb-1' />
                        RECENT POSTS
                    </div>
                    <ul className="list-group list-group-flush">
                        <Link to="/blog/pros-and-cons-of-history-optional-for-upsc" className='civil-link'>
                            <li className="list-group-item d-flex right-list-container civil-list">
                                <span className='right-list-icon rounded-circle me-1'>
                                    <IoArrowForwardCircle />
                                </span>
                                <span>
                                    Pros and Cons of History Optional for UPSC
                                </span>
                            </li>
                        </Link>
                        <Link to="/blog/how-insight-delhi-ias-quiz-makes-you-upsc-ready" className='civil-link'>
                            <li className="list-group-item d-flex right-list-container civil-list">
                                <span className='right-list-icon rounded-circle me-1'>
                                    <IoArrowForwardCircle />
                                </span>
                                <span>
                                    How Insight Delhi IAS Quiz Gets You UPSC-ready!
                                </span>
                            </li>
                        </Link>
                        <Link to="/blog/how-to-prepare-notes-for-history-optional-for-ias-exam" className='civil-link'>
                            <li className="list-group-item right-list-container civil-list">
                                <span className='right-list-icon rounded-circle me-1'>
                                    <IoArrowForwardCircle />
                                </span>
                                <span>
                                    How to Prepare Notes for History Optional for IAS Exam
                                </span>
                            </li>
                        </Link>
                        <Link to="/blog/is-history-a-good-optional-subject-for-ias-exam" className='civil-link'>
                            <li className="list-group-item right-list-container civil-list">
                                <span className='right-list-icon rounded-circle me-1'>
                                    <IoArrowForwardCircle />
                                </span>
                                <span>
                                    Is History a Good Optional Subject for the IAS exam
                                </span>
                            </li>
                        </Link>
                        <Link to="/blog/top-10-must-have-qualities-to-ace-ias-exam" className='civil-link'>
                            <li className="list-group-item right-list-container civil-list">
                                <span className='right-list-icon rounded-circle me-1'>
                                    <IoArrowForwardCircle />
                                </span>
                                <span>
                                    Top 10 Must-Have Qualities to Ace Your IAS Exam
                                </span>
                            </li>
                        </Link>
                    </ul>
                </div>
            ) : (<>
                {componentName === "currentaffairs" && <div className="card">
                    <div className="card-header list-background py-3 fs-5 text-white">
                        <input type="date" value={selectedDate} onChange={handleDateChange} style={{ cursor: "pointer!important", background: "none", width: "30px", color: "white", border: "none", borderColor: "white" }} className='me-2 mb-1' />
                        Daily Current Affairs
                    </div>
                    <ul className="list-group list-group-flush">
                        <Link to="/readmore/News/COP-27-India-China-Brazil-South-Africa-oppose-carbon-border-tax" className='civil-link'>
                            <li className="list-group-item d-flex right-list-container civil-list">
                                <span className='right-list-icon rounded-circle me-1'>
                                    <IoArrowForwardCircle />
                                </span>
                                <span>
                                    COP27 - India, China, Brazil, South Affrica oppose 'carbon border tax'
                                </span>
                            </li>
                        </Link>
                        <Link to="/readmore/News/Indias-falling-exports-Manufacturing-takes-the-biggest-hit" className='civil-link'>
                            <li className="list-group-item d-flex right-list-container civil-list">
                                <span className='right-list-icon rounded-circle me-1'>
                                    <IoArrowForwardCircle />
                                </span>
                                <span>
                                    India's falling exports: Manufacturing takes the biggest hit
                                </span>
                            </li>
                        </Link>
                        <Link to="/readmore/News/As-Mission-Prarambhs-Vikram-S-rocket-soars-into-space" className='civil-link'>
                            <li className="list-group-item right-list-container civil-list">
                                <span className='right-list-icon rounded-circle me-1'>
                                    <IoArrowForwardCircle />
                                </span>
                                <span>
                                    As Mission Prarambh's Vikram-S rocket soars into space, recalling Vikram Sarabhai, the father Indian space science
                                </span>
                            </li>
                        </Link>
                        <Link to="/readmore/News/What-viral-spillover-risk-means-and-how-it-could-lead-to-new-pandemics" className='civil-link'>
                            <li className="list-group-item right-list-container civil-list">
                                <span className='right-list-icon rounded-circle me-1'>
                                    <IoArrowForwardCircle />
                                </span>
                                <span>
                                    What 'viral spillover risk' means, and how it could lead to new pandemics
                                </span>
                            </li>
                        </Link>
                        <Link to="/readmore/News/Pakistan-is-off-FATFs-grey-list-what-does-that-mean" className='civil-link'>
                            <li className="list-group-item right-list-container civil-list">
                                <span className='right-list-icon rounded-circle me-1'>
                                    <IoArrowForwardCircle />
                                </span>
                                <span>
                                    Pakistan is off FATF's grey list: what does that mean
                                </span>
                            </li>
                        </Link>
                    </ul>
                </div>}
            </>)}
            {(componentName === "Cuet" || componentName === "neet" || componentName === "ugc_net") && componentName !== "Blog" && componentName !== "currentaffairs" && <div className="card">
                {loading ? (
                    <div style={{ height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                        <Loader />
                    </div>
                ) : (
                    articleTypes.map((typeObj, typeIndex) => {
                        const filteredArticles = allArticles.filter(a => a.Type === typeObj.Type);
                        return (
                            <div key={typeIndex}>
                                <div className="card-header list-background py-2 fs-5 text-white" style={{ backgroundColor: typeIndex % 2 === 0 ? '#800000' : '#8B0000' }}>
                                    <RxDashboard style={{ cursor: "pointer" }} className='me-2 mb-1' />
                                    {typeObj.Type}
                                </div>
                                <ul className="list-group list-group-flush mb-3">
                                    {filteredArticles.length > 0 ? filteredArticles.map((item, index) => (
                                        <Link key={index} to={`/${componentName === 'ugc_net' ? 'ugc-net' : componentName.toLowerCase()}/article/${item.Title.split(' ').join('-')}`} state={{ sn: item.Sn }} className='civil-link' style={{ cursor: 'pointer' }}>
                                            <li className="list-group-item d-flex justify-content-between right-list-container fw-normal civil-list">
                                                <span>
                                                    {item.Title}
                                                </span>
                                                <span className='right-list-icon rounded-circle fw-normal me-1'>
                                                    <BsArrowRightShort />
                                                </span>
                                            </li>
                                        </Link>
                                    )) : (
                                        <li className="list-group-item text-center py-3 text-muted">No entries found</li>
                                    )}
                                </ul>
                            </div>
                        );
                    })
                )}
                <SocialComponent />
                <ImageComponent1  componentName={componentName} />
            </div>}

            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{selectedArticle?.Title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div dangerouslySetInnerHTML={{ __html: selectedArticle?.Description }} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default CurrentAffair;